import * as confirmAction from "../../../../store/confirm/action";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";
import * as summaryReportAction from "../../../../store/summary-report/action";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    FormGroup,
    Input,
    Label,
    Modal,
    Row,
    Table,
} from "reactstrap";
import {
    DELETE_RP_BALANCE_EVENT,
    GET_RP_BALANCE_EVENT,
    SAVE_LIST_RP_BALANCE_EVENT,
    SAVE_RP_BALANCE_EVENT,
} from "helpers/url_api_constant";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import debounce from "lodash.debounce";
import LineGraphOffshore from "../Offshore/LineGraphOffshore";
import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function Offshore(props) {
    // console.log(props);
    const dispatch = useDispatch();

    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }

    const [dataGraphOffshoreBalancing, setDataGraphOffshoreBalancing] = useState([]);
    const [dataOffshoreBalancing, setDataOffshoreBalancing] = useState({ OFFSHORE_REMARK: "" });
    // const [offshoreRemark, setOffshoreRemark] = useState({ OFFSHORE_REMARK: "" })

    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = "white";

        return style;
    };

    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.CREATE_DATE < b.CREATE_DATE) {
            return -1;
        }
        if (a.CREATE_DATE > b.CREATE_DATE) {
            return 1;
        }
        return 0;
    };

    useEffect(
        function () {
            fetchDataOffshoreBalancing();
        },
        [props.summaryReportPid]
    );
    const setDispatchAction = useMemo(
        () =>
            debounce(value => {
                dispatch(summaryReportAction.setOffshoreBalancingToState(value));
            }, 300),
        []
    );

    useEffect(() => {
        setDispatchAction(dataOffshoreBalancing);
    }, [dataOffshoreBalancing]);
    // useEffect(
    //     function () {
    //         dispatch(summaryReportAction.setOffshoreBalancingToState(dataOffshoreBalancing));
    //     },
    //     [dataOffshoreBalancing]
    // );

    const fetchDataOffshoreBalancing = async () => {
        dispatch(loadingAction.showLoading());
        try {
            let [offshoreBalacing, garphOffshoreBalacing] = await Promise.all([
                post(GET_RP_BALANCE_EVENT, {
                    SUMMARYREPORT_PID:
                        props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
                }),
                post(GET_RP_BALANCE_EVENT, {
                    REPORT_DATE: moment(props.date).format("YYYY-MM-DD"),
                }),
            ]);

            // console.log(offshoreBalacing);
            // console.log(garphOffshoreBalacing);

            if (offshoreBalacing.data.rpBalancingEventList.length == 1) {
                // console.log(offshoreBalacing.data.rpBalancingEventList);
                setDataOffshoreBalancing(offshoreBalacing.data.rpBalancingEventList[0]);
            }

            if (garphOffshoreBalacing.resultCode == 200 && garphOffshoreBalacing.data != null) {
                // console.log(garphOffshoreBalacing.data.rpBalancingEventList)
                garphOffshoreBalacing = [...garphOffshoreBalacing.data.rpBalancingEventList,...offshoreBalacing.data.rpBalancingEventList.map((row)=>({...row,REPORT_DATE:props.date}))];

                setDataGraphOffshoreBalancing(garphOffshoreBalacing);
            } else {
                setDataGraphOffshoreBalancing([]);
            }

            // console.log(dataGraphOffshoreBalancing);
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    return (

        <div>
            <Row className="mt-0">
                <Col
                    sm="6"
                    className="d-flex align-items-center justify-content-end"
                >
                    <h5
                        className="mb-0 sm-0 font-size-15"
                        style={{ color: "#2FA3FF" }}
                    >
                        Unit : BBTU
                    </h5>
                </Col>
            </Row>

            <Row className="mt-0">
                <Col lg="6">
                    <Row>
                        <div>
                            {/* className="table-responsive" */}
                            {/* hover-table-highlight */}
                            <Table className="table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th
                                            colSpan={5}
                                            style={{
                                                backgroundColor: "#556ee64a",
                                                color: "#2FA3FF",
                                                textAlign: "center",
                                            }}
                                        >
                                            {" "}
                                            Offshore Balancing
                                        </th>
                                    </tr>
                                    <tr>
                                        <th
                                            style={{
                                                backgroundColor: "#556ee678",
                                                color: "#2FA3FF",
                                                textAlign: "center",
                                                width: "20%",
                                            }}
                                        >
                                            Zone
                                        </th>
                                        <th
                                            style={{
                                                backgroundColor: "#667eef85",
                                                color: "#2FA3FF",
                                                textAlign: "center",
                                                width: "20%",
                                            }}
                                        >
                                            Entry
                                        </th>
                                        <th
                                            style={{
                                                backgroundColor: "#5868b785",
                                                color: "#2FA3FF",
                                                textAlign: "center",
                                                width: "20%",
                                            }}
                                        >
                                            Exit
                                        </th>
                                        <th
                                            style={{
                                                backgroundColor: "#515c9385",
                                                color: "#2FA3FF",
                                                textAlign: "center",
                                                width: "20%",
                                            }}
                                        >
                                            Balancing
                                        </th>
                                    </tr>
                                </thead>
                                <tbody
                                    style={{ color: "#FFFFFF", textAlign: "center" }}
                                >
                                    <tr>
                                        <td>Total</td>
                                        <td>{numberFormat(dataOffshoreBalancing.BALANCING_ENTRY / 1000, 2)}</td>
                                        <td>{numberFormat(dataOffshoreBalancing.BALANCING_EXIT / 1000, 2)}</td>
                                        <td>{numberFormat(dataOffshoreBalancing.BALANCING_BALANCE, 2)} %</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                    <Row>
                        <div className="table-responsive mt-0">
                            {/* hover-table-highlight */}
                            <Table className="table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        {/* <th>#</th> */}
                                        <th
                                            style={{
                                                backgroundColor: "#556ee64a",
                                                color: "#2FA3FF",
                                                textAlign: "center",
                                                width: "100%",
                                            }}
                                        >
                                            Offshore Remark
                                        </th>
                                    </tr>
                                </thead>
                                <tbody
                                    style={{ color: "#FFFFFF", textAlign: "center" }}
                                >
                                    <tr>
                                        <td>
                                            <Col sm={12}>
                                                <Input
                                                    placeholder="-"
                                                    type="textarea"
                                                    rows="3"
                                                    style={{
                                                        border: "solid 1px #FFFFFF",
                                                        color: "#FFFFFF",
                                                    }}
                                                    className="form-control"
                                                    onChange={(e) => setDataOffshoreBalancing(
                                                        {
                                                            ...dataOffshoreBalancing,
                                                            OFFSHORE_REMARK: e.target.value
                                                        })
                                                    }
                                                    value={dataOffshoreBalancing.OFFSHORE_REMARK}
                                                />
                                            </Col>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                </Col>

                <Col lg="6">
                    <CardTitle
                        className="mb-0"
                        style={{ color: "#2FA3FF", fontSize: "25px" }}
                    >
                        Offshore
                    </CardTitle>
                    <LineGraphOffshore
                        data={dataGraphOffshoreBalancing}
                        date={props.date}
                        summaryReportPid={props.summaryReportPid}
                    />
                </Col>
            </Row>
        </div >
    );
}

Offshore.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
    summaryReportPid: PropTypes.any,
};

export default Offshore;